var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asset-receive"},[_c('div',{staticClass:"asset-summary"},[_c('dna-asset-summary',{staticClass:"asset-summary"})],1),_c('div',{staticClass:"asset-tabs"},[_c('dna-nav-second',{attrs:{"dataSource":[
        {
          text: _vm.$t('asset.receive'),
          value: '/asset/dlpreceive'
        },
        {
          text: _vm.$t('asset.send'),
          value: '/asset/dlpsend'
        }
      ]},on:{"navSecondHandle":_vm.navSecondHandle}})],1),_c('div',{staticClass:"asset-receive-content"},[_c('dna-wrapper',[_c('dna-asset-receive-form')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }